// src/components/Board/BoardList.js
import React, { useEffect, useState } from "react";
import boardApi from "../../api/boardApi";

const BoardList = ({ onSelectBoard, selectedBoard }) => {
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const res = await boardApi.get("/api/boards/");
        setBoards(res.data);
      } catch (err) {
        console.error("❌ 게시판 목록 불러오기 실패", err);
      }
    };
    fetchBoards();
  }, []);

  return (
    <div>
      <h2 className="text-lg font-bold mb-2">📁 게시판</h2>
      <ul className="space-y-1">
        {boards.map((board) => (
          <li
            key={board.slug}
            onClick={() => onSelectBoard(board.slug)}
            className={`cursor-pointer px-2 py-1 rounded hover:bg-blue-100 ${
              selectedBoard === board.slug ? "bg-blue-200 font-semibold" : ""
            }`}
          >
            {board.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BoardList;